var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "card table-responsive" },
    [
      _vm.loading || _vm.emErro
        ? _c(
            "div",
            { staticClass: "d-flex justify-center align-center pa-4" },
            [
              _vm.loading
                ? _c("v-progress-circular", {
                    attrs: { size: 35, color: "primary", indeterminate: "" }
                  })
                : _vm._e(),
              _vm.emErro
                ? _c(
                    "div",
                    { staticStyle: { color: "red", "font-weight": "bold" } },
                    [_vm._v(_vm._s(this.errorMessage))]
                  )
                : _vm._e()
            ],
            1
          )
        : _c("v-data-table", {
            staticClass: "custom_table_class",
            attrs: {
              headers: _vm.headers,
              items: _vm.calculos,
              "item-class": _vm.rowBackground,
              "hide-default-footer": "",
              "mobile-breakpoint": "0"
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item.title",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-chip",
                        {
                          staticClass: "chip",
                          class: { total: item.title == "Total" },
                          attrs: { color: _vm.getColor(item.title) }
                        },
                        [_vm._v(" " + _vm._s(item.title) + " ")]
                      )
                    ]
                  }
                },
                {
                  key: "item.participacao",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.percentageHelper.formatPercentage(
                              item.participacao
                            )
                          )
                        )
                      ])
                    ]
                  }
                },
                {
                  key: "item.saldo",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(_vm.currencyHelper.formatValue(item.saldo)) +
                          " "
                      )
                    ]
                  }
                },
                {
                  key: "item.liquido",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(_vm.currencyHelper.formatValue(item.liquido)) +
                          " "
                      )
                    ]
                  }
                },
                {
                  key: "item.valor",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(_vm.currencyHelper.formatValue(item.valor)) +
                          " "
                      )
                    ]
                  }
                },
                {
                  key: "item.percent",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.percentageHelper.formatPercentage(item.percent)
                          ) +
                          " "
                      )
                    ]
                  }
                },
                {
                  key: "item.acumulado",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.currencyHelper.formatValue(item.acumulado)
                          ) +
                          " "
                      )
                    ]
                  }
                }
              ],
              null,
              true
            )
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }